<template>
    <div class="">
        <div class="room__collapse accordion" id="accordionExample">
            <div class="card">
                <div class="card-header p-0" id="headingOne">
                    <button class="room__collapse__header" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Advanced Search
                        <svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="5.414" viewBox="0 0 9.414 5.414" class="arrow__collapsible">
                        <g id="Grupo_6049" data-name="Grupo 6049" transform="translate(8.707 4.707) rotate(180)">
                            <line id="Línea_794" data-name="Línea 794" x2="4" y2="4" transform="translate(4)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                            <line id="Línea_795" data-name="Línea 795" x1="4" y2="4" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                        </g>
                        </svg>
                    </button>
                </div>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <h1 class="view__title title--1" v-html="title_page"/>
                        <LocalFormSearch
                        :form_format="form_format"
                        :form_data="form_data"
                        :form_resources="form_resources"
                        :array_options="array_options"
                        :boolean_options="boolean_options"
                        :radio_options="radio_options"
                        :simbol_options="simbol_options"
                        :excl_options="excl_options"
                        :module_name="module_name"
                        @debounceInput="debounceInput"
                        @resetList="resetList"
                    />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <v-card>
                    <DinamicTableInfiniteLoader
                        :name="'AdvancedSearch'"
                        :selectable_columns="selectable_columns"
                        :array_options_table="array_options_table"
                        :headers="table_headers"
                        :items="main_items"
                        :pagination="pagination"
                        :totals="totals"
                        :search="search"
                        :checkable="true"
                        :size="30"
                        :historiable="historiable"
                        :updateable="updateable"
                        :detail_text="detail_text"
                        :for_reports="for_reports"
                        @emitToUpdate="$emit('modal_update', $event)"
                        @fetchMainList="fetchMainList($event)"
                        @history="$emit('history', $event)"
                        @paginateMoreRecords="paginateMoreRecords($event)"
                        @orderRequest="orderRequest($event)"
                        ref="main_table"
                    />
                </v-card>
            </div>
        </div>

        <WaitingModal v-if="checkeable === undefined && !checkeable"/>
    </div>
</template>

<script>

import WaitingModal     from    '@/components/WaitingModal'
import DinamicTableInfiniteLoader     from    '@/components/DinamicTableInfiniteLoader'
import LocalFormSearch  from    './LocalFormSearch'
import Methods          from    './methods'
import Watchers         from    './watchers'
import Resources from './resources'
import { Notyf }        from    'notyf'
import _ from 'lodash'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'AdvancedSearch',

    props:[
        'module_name',
        'detail_text',
        'checkeable',
        'form_format',
        'form_data',
        'rest_api',
        'rest_api_pagination',
        'historiable',
        'updateable',
        'table_headers',
        'db_totals',
        'search',
        'show_sq_ft',
        'for_reports',
        'selectable_columns',
        'radio_options',
        'boolean_options',
        'status_options',
        'excl_options',
        'simbol_options',
        'shift_criteria_options'
    ],

    components:{
        WaitingModal,
        LocalFormSearch,
        DinamicTableInfiniteLoader,
    },

    mixins:[
        Methods,
        Watchers
    ],

    data(){
        return{
            notyf,
            title_page:                 'Advanced search',
            main_items:                  [],
            array_options:              {},
            selectAll:                  false,
            form_resources:             Resources,
            tasks: [],
            pagination: null,
            array_options_table: [],
            first_time_flags: {},
            totals: {},
            view_by_fields: true,
            is_mounted: 0,
            local_params: {}

        }
    },

    methods:{

        debounceInput:  _.debounce(function (e)  {
            this.form_data[e.field] = e.value
        },800),


        checkingOrigins(main_items_origin_id)
        {
            main_items_origin_id.forEach(origin_id => 
            {
                let indexFound = this.main_items.findIndex(room => room.origin_id === origin_id)
                
                if(indexFound > -1)
                {
                    this.main_items[indexFound].checked = true
                    window.$(`#advancedItems${indexFound}`).prop('checked', true)
                }
            })
        },

        replacingMainItems(main_items, search_key = 'origin_id')
        {
            main_items.forEach(updated_room => {

                let found_index = this.main_items.findIndex(room => room[search_key] === updated_room[search_key])
                if(found_index > -1)
                {
                    updated_room.checked = true;
                    this.main_items.splice(found_index, 1, updated_room)
                }
            })
        },

        async paginateMoreRecords(params)
        {
            if(this.main_items.length >= this.pagination?.total)
            {
                return;
            }
            
            await this.showLoader()

            await this.apiRequest(params)
        },

        async fetchMainList(params) 
        {
            this.local_params = params
            this.main_items = [];
            await this.showLoader()
            await this.apiRequest(params, true)
        },


        async loadMoreRecords(data, reset_list)
        {
            if(reset_list)
            {
                this.main_items = []
            }

            if(data.pagination && data.pagination.current_page <= 1 && this.is_mounted <= 1)
            {
                this.fillData(data)
            }

            let main_items = data.pagination.data

            if(main_items.length)
            {
                main_items.forEach((item) => {
                    item.checked = this.$refs.main_table.select_all
                    this.main_items.push(item)
                })
            }
            
            this.pagination = data.pagination

            if(data.totals)
            {

                if(this.db_totals.length)
                {
                    this.totals = data.totals

                    const db_totals_map = new Map()

                    this.db_totals.forEach((dbTotal) => 
                    {
                        const db_total_keys = Object.keys(dbTotal)
                        db_total_keys.forEach((db_total_key) => 
                        {
                            db_totals_map.set(db_total_key, dbTotal[db_total_key].show)
                        })
                    })

                    this.totals.forEach((total) => 
                    {
                        const total_keys = Object.keys(total)

                        total_keys.forEach((total_key) => 
                        {
                            if (db_totals_map.has(total_key)) 
                            {
                                total[total_key].show = db_totals_map.get(total_key)
                            }
                        })
                    })
                }
                else
                {
                    const totals_map = new Map()

                    if(this.totals.length)
                    {
                        this.totals.forEach((total) => 
                        {
                            const total_keys = Object.keys(total)
                            total_keys.forEach((db_total_key) => 
                            {
                                totals_map.set(db_total_key, total[db_total_key].show)
                            })
                        })
                    }

                    this.totals = data.totals

                    this.totals.forEach((total) => 
                    {
                        const total_keys = Object.keys(total)

                        total_keys.forEach((total_key) => 
                        {
                            if (totals_map.has(total_key)) 
                            {
                                total[total_key].show = totals_map.get(total_key)
                            }
                        })
                    })
                }

                this.db_totals = []
            }

            await this.hideLoader(data.pagination.data)
        },

        isSelectAll()
        {
            return this.$refs.main_table.select_all
        },

        async showLoader()
        {
            this.$refs.main_table.showLoader()
        },

        async hideLoader(data)
        {
            this.$refs.main_table.hideLoader(data)
        },

        orderRequest(event)
        {
            console.log(event)
            this.$emit('orderRequest', event)
        },

        async getInitialData() {
            if(this.module_name == 'room_tasks')
            {
                const res = await this.get(`new_reports/generate_options?report_name=${this.module_name}`)

                if(res.status)
                {
                    console.log(res.data)
                    this.array_options = res.data
                }
                else
                {
                this.error_handling(res)
                }
            }
        },



    },

    async mounted()
    {
        if(this.hasPermissions(['Report Read', 'Report Write']))
        {
            const query_params = this.$route.query
            const query_filters = Object.keys(query_params).map(key => ({ key, value: query_params[key] }));

            if(query_filters && query_filters.length)
            {
                let form_data = {...this.form_data}

                query_filters.forEach(element => 
                {
                    form_data[element.key] = element.value
                    this.first_time_flags[element.key] = element.value
                })

                this.form_data = form_data

                // Remove the query params from the URL
                this.$router.replace({ query: null });
            }
        }
        else
        {
            window.location.href = '/'
        }
    },


}

</script>